import React from "react";

// Draws a Material Design Icons path from @mdi/js, the icon set the mobile app uses.
const MdiIcon = ({ path, size = 24, color = "currentColor", style, title, className }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    style={style}
    className={className}
    role={title ? "img" : undefined}
    aria-hidden={title ? undefined : "true"}
    focusable="false"
  >
    {title ? <title>{title}</title> : null}
    <path d={path} fill={color} />
  </svg>
);

export default MdiIcon;
